"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorNotFound = exports.ErrorBoundary = void 0;
const error_boundary_1 = __importDefault(require("./error.boundary"));
exports.ErrorBoundary = error_boundary_1.default;
const error_notfound_1 = __importDefault(require("./error.notfound"));
exports.ErrorNotFound = error_notfound_1.default;
